<template>
  <div style="margin-top:-10px !important">
    <RecordNotFound v-if="status_code == 404" :message="status_message"></RecordNotFound>
    <template v-else>
      <b-row
        class="hidden-sm-down d-print-none px-pad border-bottom justify-content-center"
        style="height:42px"
      >
        <!-- <b-col m5="1"></b-col> -->
        <b-col cols="3" md="3" xl="3" lg="3" sm="3" xs="3" class="text-left px-0">
          <!--  invoice header details -->

          <!--  invoice no and status name -->
          <h2 class="custom-page-title mb-2 mt-1">{{ list.header_details.crdt_no }}</h2>
        </b-col>
        <b-col cols="9" md="9" xl="9" lg="9" sm="9" xs="9" class="text-right px-0">
          <router-link
            :to="{
              name: 'CreditRefund',
              params: { id: $route.params.id },
              query: { page: 'credit' },
            }"
            v-if="
              list.header_details.crdt_status == 4 &&
                RoutePermission(false, '', 'invoice', 'credit', 'refund')
            "
          >
            <b-button variant="success" size="sm" class="mr-2">Refund</b-button>
          </router-link>
          <b-button
            variant="success"
            size="sm"
            class="mr-2"
            v-if="
              list.header_details.crdt_status == 4 &&
                RoutePermission(false, '', 'invoice', 'credit', 'create')
            "
            v-on:click.stop="callavailableinvoicemodal()"
            >Apply To Invoice</b-button
          >
          <b-button-group variant="light">
            <b-button
              size="sm"
              v-if="
                RoutePermission(false, '', 'bill', 'credit', 'update') &&
                  list.header_details.crdt_status != '6'
              "
              :to="{
                name: 'CreditUpdate',
                params: { id: $route.params.id },
                query: { page_from: 'view' },
              }"
              variant="light"
            >
              <i class="la la-edit la-lg"></i>
            </b-button>
            <!-- <b-button
              variant="light"
              size="sm"
              title="delete"
             
              v-if="parseFloat(list.header_details.crdt_status) <= 4 && (parseFloat(list.header_details.available_amount) == parseFloat(list.header_details.received_amount)) &&  RoutePermission(false,'','invoice','credit','delete')"
              v-b-modal.deletecredit
            >
              <i class="fa fa-trash"></i>
          </b-button>-->
            <!-- <b-button variant="light" size="sm" title="email" @click="sendmail()">
              <i class="fa fa-envelope-o"></i>
          </b-button>-->
            <b-button variant="light" size="sm" title=" print" @click="handlePrint()">
              <i class="la la-print la-lg"></i>
            </b-button>
            <b-dropdown
              right
              text="More"
              variant="light"
              size="sm"
              style="height:31px !important"
              v-if="
                RoutePermission(false, '', 'bill', 'credit', 'update') ||
                  RoutePermission(false, '', 'bill', 'credit', 'delete') ||
                  RoutePermission(false, '', 'invoice', 'credit', 'email') ||
                  RoutePermission(false, '', 'invoice', 'settings', 'templates')
              "
            >
              <b-dropdown-item
                v-if="
                  RoutePermission(false, '', 'bill', 'credit', 'update') &&
                    list.header_details.crdt_status != '6' &&
                    list.header_details.crdt_status != '5'
                "
                v-on:click="redirect = 0"
                @click="
                  handlingapprovingmodal({
                    content: 'Are you sure you want to cancel this Credit ?',
                    title: 'Cancel Credit - ' + list.header_details.crdt_no,
                    module: 'credit/cancelcredit',
                    data: JSON.stringify({
                      id: $route.params.id,
                    }),
                    RoutePlace: '',
                    isRoute: 'false',
                    type: 'cancel',
                  })
                "
              >
                <i class="la la-ban la-lg mr-3"></i>Cancel
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  list.header_details.crdt_status == 6 ||
                    (parseFloat(list.header_details.crdt_status) <= 4 &&
                      parseFloat(list.header_details.available_amount) ==
                        parseFloat(list.header_details.received_amount) &&
                      RoutePermission(false, '', 'invoice', 'credit', 'delete'))
                "
                @click="
                  handlingapprovingmodal({
                    content: 'Are you sure you want to delete this credit ?',
                    title: 'Delete Credit - ' + list.header_details.crdt_no,
                    module: 'credit/deletecredit',
                    data: JSON.stringify({
                      id: $route.params.id,
                    }),
                    RoutePlace: 'Credit',
                    isRoute: 'true',
                    type: 'delete',
                    route_history: credit_index_history,
                  })
                "
              >
                <i class="la la-trash la-lg mr-3"></i>Delete
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  list.header_details.crdt_status != '6' &&
                    RoutePermission(false, '', 'invoice', 'credit', 'email')
                "
                :to="{
                  name: 'Email',
                  query: {
                    tns_type: 'Credit Note',
                    tns_date: list.header_details.crdt_date,
                    cus_id: list.header_details.cus_id,
                    cus_name: list.header_details.cus_name,
                    tns_no: list.header_details.crdt_no,
                    tns_mail: list.header_details.cus_mail,
                    tns_currency: list.header_details.cus_currency,
                    id: $route.params.id,
                    date_format: org_details.date_format,
                  },
                }"
              >
                <i class="la la-envelope-o la-lg mr-3"></i>
                Mail
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  list.header_details.crdt_status != '6' &&
                    !list.header_details.eway_bill_no &&
                    RoutePermission(false, '', 'bill', 'credit', 'update')
                "
                v-b-modal.addeway
              >
                <i class="la la-truck la-lg mr-3"></i>Assosiate E-way bill Number
              </b-dropdown-item>
              <b-dropdown-item
                @click="showFullLayout"
                v-if="RoutePermission(false, '', 'invoice', 'settings', 'templates')"
              >
                <i class="la la-cog la-lg mr-3"></i>Customize Print
              </b-dropdown-item>
            </b-dropdown>

            <b-button
              variant="light"
              size="sm"
              title="close"
              :to="credit_index_history ? credit_index_history : { name: 'Credit' }"
            >
              <i class="la la-remove la-lg text-decoration-none"></i>
            </b-button>
            <!-- <a title=" print" id="print_url" size="sm" href="#" class="btn btn-light"></a> -->
          </b-button-group>
          <!-- <a title=" attach" href="#" class="btn btn-light" @click="$router.go(-1)">
            <i class="la la-remove la-lg text-decoration-none"></i>
        </a>-->
        </b-col>
      </b-row>
      <!-- 
      page first block - detailed bloc k maount
    -->

      <div class="view-block-tab" style="margin-left:-20px;margin-right:-20px;">
        <b-tabs class="customer_view_tab no-flex-grow mb-5 mt-2 border-tab">
          <b-tab title="Credit Note View" :title-link-class="{ 'd-print-none': true }" class="p-0">
            <div class="view-block d-flex d-print-none">
              <b-row class="w-100">
                <b-col cols="12" lg="12" md="12" class="py-3 px-2">
                  <div class="d-flex ml-3">
                    <div class="verticalLine5 pl-3 ml-4">
                      <h6>Received Amount</h6>

                      <span>{{
                        currency_symbol +
                          " " +
                          parseFloat(list.header_details.received_amount).toLocaleString(
                            undefined,
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                          )
                      }}</span>
                    </div>
                    <div class="verticalLine4 pl-3 ml-5">
                      <h6>Available Amount</h6>

                      <span>{{
                        currency_symbol +
                          " " +
                          parseFloat(list.header_details.available_amount).toLocaleString(
                            undefined,
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                          )
                      }}</span>
                    </div>
                    <div class="verticalLine3 pl-3 ml-5">
                      <h6>Used Amount</h6>

                      <span>{{
                        currency_symbol +
                          " " +
                          parseFloat(list.header_details.used_amount).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}</span>
                    </div>
                    <div class="verticalLine5 pl-3 ml-5">
                      <h6>Refund Amount</h6>

                      <span>{{
                        currency_symbol +
                          " " +
                          parseFloat(list.header_details.refund_amount).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}</span>
                    </div>
                    <div class="ml-auto float-right" style="margin-right:-12px ">
                      <h5 class="text-right">
                        {{
                          getPresentValue(
                            list.crdt_status,
                            "crdt_status_id",
                            list.header_details.crdt_status,
                            "crdt_status_name"
                          )
                        }}
                      </h5>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>

            <p
              class="text-link fw-semi-bold px-pad pt-2"
              v-if="
                list.header_details.crdt_status != '6' &&
                  !list.header_details.eway_bill_no &&
                  list.header_details.total_credit_amount >= 50000 &&
                  parseFloat(
                    list.header_details.total_credit_amount - list.header_details.adjusted_amount
                  ) > 50000
              "
            >
              <span
                v-b-modal.addeway
                class="cursor_pointer"
                v-if="RoutePermission(false, '', 'bill', 'credit', 'update')"
              >
                <i class="fa fa-truck"></i>
                Assosiate E-way bill Number
              </span>
            </p>
            <p v-else-if="list.header_details.eway_bill_no" class="px-pad pt-2">
              e-way bill Number : {{ list.header_details.eway_bill_no }}
              <span class="text-link" v-if="RoutePermission(false, '', 'bill', 'credit', 'update')">
                <i class="la la-edit la-lg cursor_pointer mb-2" v-b-modal.addeway></i>
              </span>
            </p>
            <StandardPrint
              class="p-4 custom-md-width"
              :printlabel="printlabel"
              :showprintlabel="showprintlabel"
              :list="list"
              v-if="crdt_settings_details.print.templateId == 8"
            ></StandardPrint>
            <SpreadsheetPrint
              class="p-4 custom-md-width"
              :printlabel="printlabel"
              :showprintlabel="showprintlabel"
              :list="list"
              v-if="crdt_settings_details.print.templateId == 9"
            ></SpreadsheetPrint>
            <RetailPrint
              class="p-4 custom-md-width"
              :printlabel="printlabel"
              :showprintlabel="showprintlabel"
              :list="list"
              v-if="crdt_settings_details.print.templateId == 10"
            ></RetailPrint>
          </b-tab>
          <!--  payment amount used in invoice tabs -->
          <b-tab
            :title="'Credits Applied (' + list.invoice_details_payment.length + ')'"
            :title-link-class="{ 'd-print-none': true }"
            v-if="list.invoice_details_payment.length > 0"
            class="p-0"
          >
            <b-row style="max-width:1200px;" class="px-0">
              <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                <table
                  class="table table-bordered sales-table view-page-table last-child-border-none"
                >
                  <thead>
                    <tr>
                      <th class="text-left" width="20%" style="padding-left:22px !important">
                        Invoice Number
                      </th>
                      <th>Invoice Date</th>
                      <th>Invoice Amount</th>
                      <th class="text-right">Amount</th>
                      <th style="padding-right:22px !important"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in list.invoice_details_payment"
                      :key="item.id"
                      @mouseover="showByIndex = index"
                      @mouseout="showByIndex = null"
                    >
                      <td
                        class="text-left"
                        width="20%"
                        style="padding-left:22px !important"
                        v-if="RoutePermission(false, '', 'invoice', 'invoice', 'index')"
                      >
                        <router-link
                          class="event-link ml-2"
                          :to="{
                            name: 'InvoiceView',
                            params: { id: item.inv_hdr_id },
                            query: {
                              page_from: 'credit_view',
                              id: $route.params.id,
                              view_no: list.header_details.crdt_no,
                            },
                          }"
                          >{{ item.inv_no }}</router-link
                        >
                      </td>
                      <td class="text-link" v-else>{{ item.inv_no }}</td>
                      <td>{{ getDateFormat(item.created_date) }}</td>
                      <td>
                        {{
                          currency_symbol +
                            " " +
                            parseFloat(item.grand_total).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                      <td class="text-right">
                        {{
                          currency_symbol +
                            " " +
                            parseFloat(item.crdt_applied_amount).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                      <td width="50px" style="padding-right:22px !important">
                        <template v-if="RoutePermission(false, '', 'bill', 'credit', 'delete')">
                          <span v-show="showByIndex === index">
                            <i
                              class="glyphicon glyphicon-trash"
                              @click="deletecreditpayment(index)"
                            ></i>
                          </span>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-tab>
          <!--  payment amount refunded details -->
          <b-tab
            :title="'Refund (' + list.refund_payment_details.length + ')'"
            :title-link-class="{ 'd-print-none': true }"
            v-if="list.refund_payment_details.length > 0"
            class="p-0 d-print-none"
          >
            <b-row style="max-width:1200px;" class="px-0">
              <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                <table
                  class="table table-bordered sales-table view-page-table last-child-border-none"
                >
                  <thead>
                    <tr>
                      <th class="text-left" width="20%" style="padding-left:22px !important">
                        Date#
                      </th>
                      <th>Payment Mode</th>
                      <th class="text-right">Amount Refunded</th>
                      <th style="padding-right:22px !important"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in list.refund_payment_details"
                      :key="item.id"
                      @mouseover="showByIndex = index"
                      @mouseout="showByIndex = null"
                    >
                      <td class="text-left" width="20%" style="padding-left:22px !important">
                        {{ getDateFormat(item.crdt_applied_date) }}
                      </td>
                      <td>{{ item.method_name }}</td>
                      <td class="text-right">
                        {{
                          currency_symbol +
                            " " +
                            parseFloat(item.crdt_applied_amount).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                      <td width="50px" style="padding-right:22px !important">
                        <span v-show="showByIndex === index">
                          <i
                            class="glyphicon glyphicon-trash"
                            @click="deleterefund(index)"
                            v-if="RoutePermission(false, '', 'invoice', 'credit', 'refund')"
                          ></i>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
      <!--  to send an email -->
      <SendMail content="credit" module="credit" :mail_id="list.header_details.cus_mail"></SendMail>
      <DeleteCreditRecord
        v-on:setAmountDetails="updateAmountDetails($event)"
        :CreditDeleteDetail="CreditDeleteDetail"
        @recallRecord="recallRecord()"
      ></DeleteCreditRecord>
      <DeleteRefundRecord
        v-on:setRefundAmountDetails="updateRefundAmountDetails($event)"
        :RefundDeleteDetail="RefundDeleteDetail"
        @recallRecord="recallRecord()"
        page="credit"
      ></DeleteRefundRecord>
      <InvoiceAvailable
        :currency="currency_symbol"
        :field="creditDetails"
        :title="'Apply Credits from ' + list.header_details.crdt_no"
        check="availablecreditinvoice"
        submit="updateCreditInvoice"
        page="credit"
        @checkCustomer="checkCustomer"
      ></InvoiceAvailable>
      <!--  paymetn delete modal -->
      <GlobalModal
        :content="content"
        :module="module"
        :title="title"
        :data="globalmodaldata"
        :isRoute="isRoute"
        :RoutePlace="RoutePlace"
        :type="globalmodaltype"
        :route_history="route_history"
        v-on:setSuccessHandlingModal="getSuccessHandlingModal"
      />
      <!--  print template activation -->
      <FlyOver :show_full_layout="show_full_layout">
        <template slot="page-content" v-if="show_full_layout">
          <h5 class="mb-4 fw-semi-bold text-left">
            Credit Note Templates
            <span class="float-right pr-2">
              <i
                class="la la-close cursor_pointer fw-semi-bold pr-1"
                @click="show_full_layout = false"
              ></i>
            </span>
          </h5>
          <CreditPrint :show_full_layout="show_full_layout" :path="$route.fullPath"></CreditPrint>
        </template>
      </FlyOver>
      <EwayBill
        :eway_bill_no="list.header_details.eway_bill_no"
        :id="list.header_details.crdt_hdr_id"
        @setewaybillno="ewayno()"
        :module_name="'credit'"
      ></EwayBill>
    </template>
  </div>
</template>

<script>
import getPageTitle from "@/utils/get-page-title"; // to set page title
import RecordNotFound from "@/pages/Error/RecordNotFound";
import { mapState, mapGetters } from "vuex"; // get data set in the state in vuex
import DeleteCreditRecord from "@/components/Modal/InvoiceModal/DeleteCreditRecord"; // modal for deleting created credit used record
import CreditPrint from "@/pages/Settings/Invoice/Creditprint";
import FlyOver from "@/components/Layout/Flyover";
import store from "@/store/index"; // vuex store fucntion
import StandardPrint from "@/components/Form/Credit/Print/Standard";
import SpreadsheetPrint from "@/components/Form/Credit/Print/Spreadsheet";
import RetailPrint from "@/components/Form/Credit/Print/Retail";
import DeleteRefundRecord from "@/components/Modal/InvoiceModal/DeleteRefundRecord"; // modal for deleting created credit used record
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import InvoiceAvailable from "@/components/Modal/InvoiceModal/InvoiceAvailable"; // credits available modal\
import SendMail from "@/components/Modal/MailModal"; // modal for sending mail
import EwayBill from "@/components/Modal/EwayBill";
export default {
  name: "crdtInvoiceView",
  mixins: [notificationMixin],
  data() {
    return {
      isRoute: "",
      RoutePlace: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: "",
      showByIndex: null,
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      show_full_layout: false,
      printlabel: "",
      showprintlabel: false,
      currency_symbol: "",
      creditDetails: {},
      total_in_words: "",
      imageSrc: "",
      CreditDeleteDetail: {},
      RefundDeleteDetail: {},
      route_history: "",
      deletedpymntrecord: "", // to remove the item from the view page
      deletedrefundrecord: "", // to remove the item from the view page
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // notification design class
      field: {},
    };
  },
  components: {
    CreditPrint,
    FlyOver,
    SendMail,
    DeleteCreditRecord,
    StandardPrint,
    SpreadsheetPrint,
    RetailPrint,
    DeleteRefundRecord,
    InvoiceAvailable,
    EwayBill,
    RecordNotFound,
  },
  methods: {
    checkCustomer(ev) {
      window.Messenger().post({
        extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
        message: ev.status_message,
        type: ev.status_type,
        showCloseButton: true,
      });
      this.$root.$emit("bv::hide::modal", "availableinvoice");
    },
    ewayno() {
      this.list.header_details.eway_bill_no = this.eway_bill_no;
    },
    getSuccessHandlingModal(ev) {
      if (this.globalmodaltype == "approve" || this.globalmodaltype == "cancel") {
        this.list.header_details.crdt_status = ev.data.status_id;
        this.list.invoice_amount_detail.crdt_status_name = ev.data.status_name;
      }
    },

    //Customize overlay for Print
    async showFullLayout() {
      await store
        .dispatch("settings/fetchinvoicesettings", {
          stg_menu: "Credit Note",
        })
        .then(() => {
          this.show_full_layout = true;
        });
    },
    // delete the selected recorc credti applied
    sendmail() {
      this.$root.$emit("bv::show::modal", "modulemail");
    },
    // call avialbel modal
    callavailableinvoicemodal() {
      this.creditDetails = {
        id: this.list.header_details.cus_id,
        unused_amount: this.list.header_details.available_amount,
        apply_unused_amount: this.list.header_details.available_amount,
      };
      this.$root.$emit("bv::show::modal", "availableinvoice");
      EventBus.$emit("invoicedetails");
    },
    // delete the selected recorc credti applied
    deleterefund(index) {
      this.$root.$emit("bv::show::modal", "deleterefundpayment");
      this.RefundDeleteDetail = this.list.refund_payment_details[index];
      this.deletedrefundrecord = index;
    },
    // delete the selected recorc credti applied
    deletecreditpayment(index) {
      this.$root.$emit("bv::show::modal", "deletecreditpayment");
      this.CreditDeleteDetail = this.list.invoice_details_payment[index];
      this.deletedpymntrecord = index;
    },
    updateAmountDetails(event) {
      //  subtrach applied amount from used amount
      this.list.header_details.used_amount =
        parseFloat(this.list.header_details.used_amount) -
        parseFloat(event.CreditDeleteDetail.crdt_applied_amount);
      // add applied amount to available amount
      this.list.header_details.available_amount =
        parseFloat(this.list.header_details.available_amount) +
        parseFloat(event.CreditDeleteDetail.crdt_applied_amount);
      //  remove the record from list
      this.list.invoice_details_payment.splice(this.deletedpymntrecord, 1);
      this.list.header_details.crdt_status = 4; // change the status to open
    },
    updateRefundAmountDetails(event) {
      //  subtrach applied amount from used amount
      this.list.header_details.refund_amount =
        parseFloat(this.list.header_details.refund_amount) -
        parseFloat(event.RefundDeleteDetail.crdt_applied_amount);
      // add applied amount to available amount
      this.list.header_details.available_amount =
        parseFloat(this.list.header_details.available_amount) +
        parseFloat(event.RefundDeleteDetail.crdt_applied_amount);
      //  remove the record from list
      this.list.refund_payment_details.splice(this.deletedrefundrecord, 1);
      this.list.header_details.crdt_status = 4; // change the status to open
    },
    //  delete credit
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.route_history = ev.route_history || "";
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },
    getTempProps() {
      this.field = this.$store.state.permission.print_settings_details["Credit Note"].template_list;
    },
    recallRecord() {
      store.dispatch("credit/fetchviewList", parseInt(this.$route.params.id));
    },
    async handlePrint() {
      store.dispatch("credit/fetchviewList", parseInt(this.$route.params.id));

      if (this.status_code == 200) {
        await this.getTempProps();
        document.title =
          this.list.header_details.crdt_no + " / " + this.list.header_details.crdt_date;
        var id;
        var style;
        var size;
        if (this.crdt_settings_details.print.templateId == 8) {
          id =
            this.field.temp_prop.paper_size == 0
              ? this.field.temp_prop.orientation == 0
                ? "a4-standard-portrait-page"
                : "a4-standard-landscape-page"
              : this.field.temp_prop.paper_size == 1
              ? this.field.temp_prop.orientation == 0
                ? "a5-standard-portrait-page"
                : "a5-standard-landscape-page"
              : "";
          style = "standard";
          size =
            this.field.temp_prop.paper_size == 0
              ? this.field.temp_prop.orientation == 0
                ? "size:A4;"
                : "size:A4 landscape;"
              : this.field.temp_prop.paper_size == 1
              ? this.field.temp_prop.orientation == 0
                ? "size:A5;"
                : "size:A5 landscape;"
              : "";
        } else if (this.crdt_settings_details.print.templateId == 9) {
          id =
            this.field.temp_prop.paper_size == 0
              ? this.field.temp_prop.orientation == 0
                ? "a4-spreadsheet-portrait-page"
                : "a4-spreadsheet-landscape-page"
              : this.field.temp_prop.paper_size == 1
              ? this.field.temp_prop.orientation == 0
                ? "a5-spreadsheet-portrait-page"
                : "a5-spreadsheet-landscape-page"
              : "";
          size =
            this.field.temp_prop.paper_size == 0
              ? this.field.temp_prop.orientation == 0
                ? "size:A4;"
                : "size:A4 landscape;"
              : this.field.temp_prop.paper_size == 1
              ? this.field.temp_prop.orientation == 0
                ? "size:A5;"
                : "size:A5 landscape;"
              : "";
          style = "spreadsheet";
        } else {
          id =
            this.field.temp_prop.paper_size == 0
              ? "inch3-thermal-print-page"
              : "inch4-thermal-print-page";
          style = "retail";
          size = "";
        }

        var win;
        const element = document.getElementById(id);

        var printcontent = "";
        for (
          var i = 1;
          i <= this.general_settings_details.preferences.default_print_preference;
          i++
        ) {
          this.showprintlabel = await true;
          this.printlabel = await this.general_settings_details.preferences.document_copy_label[i];
          printcontent +=
            (await ' <div style="page-break-after:always">') + element.innerHTML + "</div>";
        }

        win = window.open("", "Title", "fullscreen=yes", "titlebar=yes", "scrollbars=yes");
        win.document.write(`
            <html>
              <head>
                <title>${document.title}</title>
                 <style>
                @page{
               ${size}
                margin:0 !important;
                }
                </style>
                <link rel="stylesheet" href="${
                  process.env.VUE_APP_INVOICE_API_URL
                }/css/print/${style}.css">
              </head>
              <body class="${id}">
              ${printcontent}
              </body>
            </html>
          `);
        if (navigator.userAgent.indexOf("Safari") != -1) {
          setTimeout(() => {
            win.document.close();
            this.printlabel = "";
            this.showprintlabel = false;
            win.focus();
            win.print();
          }, 500);
          setTimeout(() => {
            win.close();
          }, 5000);
        } else {
          setTimeout(() => {
            win.document.close();
            this.printlabel = "";
            this.showprintlabel = false;
            win.focus();
            win.print();
            win.close();
          }, 500);
        }
      }
    },
    //  to get the json value
    getPresentValue(arr, prop, val, return_prop) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i][return_prop];
          break;
        }
      }
      return hasMatch;
    },
  },

  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch("credit/fetchCreditDetails").then(() => {
      store.dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Credit Note",
        stg_name: "crdt_settings_details",
      });
      next();
    });
  },
  created() {
    this.getTempProps();
    document.title = getPageTitle(
      this.list.header_details.crdt_no + " | " + this.$route.meta.title
    );
    this.initializationMessengerCode();
    this.currency_symbol = this.getDetails(
      this.$AppDetails.currency_details,
      this.list.header_details.cus_currency,
      "currency_symbol"
    );
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
  },
  computed: {
    ...mapState({
      list: (state) => state.credit.list,
      credit_details: (state) => state.credit.details,
      eway_bill_no: (state) => state.credit.eway_bill_no,
      status_code: (state) => state.credit.status_code,
      status_message: (state) => state.credit.status_message,
      status_type: (state) => state.credit.status_type,
      credit_index_history: (state) => state.credit.credit_index_history,
    }),
    ...mapGetters(["org_details", "crdt_settings_details", "general_settings_details"]),
  },
};
</script>

<style></style>
